if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        
        this.currentPage = 1
        let page = 0;
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            page++;
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        this.totalPages = page;
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
        const slideActiveItem = this.querySelector("#sliderItem-1");
        if (slideActiveItem) {
          slideActiveItem.style.background = "#979696";
        }
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.prevButton.addEventListener(
          "click",
          this.onButtonClick.bind(this)
        );
        this.nextButton.addEventListener(
          "click",
          this.onButtonClick.bind(this)
        );

        this.setButtonBehaviour()
        this.slider = this.querySelector('[id^="Slider-"]');
            let startX = 0;

        this.slider.addEventListener("touchstart", (e) => {
          startX = e.touches[0].clientX;
        });
    
        this.slider.addEventListener("touchend", (e) => {
          const endX = e.changedTouches[0].clientX;
          const diff = endX - startX;
          if (diff > 30) {
            this.prevButton.click();
          } else if (diff < -30) {
            this.nextButton.click();
          }
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        const slideItems = this.querySelectorAll(".progress-bar .item");
        slideItems.forEach((item) => {
          item.style.background = "lightgrey";
        });
        const slideActiveItem = this.querySelector(
          "#sliderItem-" + event.detail.currentPage
        );
        this.currentPage = event.detail.currentPage
        slideActiveItem.style.background = "#979696";
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        if (!activeMedia) return;
        
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia.classList.add("is-active");

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            if (activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === "stacked"
          ) {
            activeMedia.scrollIntoView({ behavior: "smooth" });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        if (!activeThumbnail) return;
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
        
        );
        this.currentPage = activeThumbnail.dataset.mediaPosition
        this.setButtonBehaviour()
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }

      setButtonBehaviour () {
          if (
          this.totalPages == this.currentPage
        ) {
          this.nextButton.setAttribute("disabled", "disabled");
        } else {
          this.nextButton.removeAttribute("disabled");
        }

        if (
          this.currentPage == 1 
        ) {
          this.prevButton.setAttribute("disabled", "disabled");
        } else {
          this.prevButton.removeAttribute("disabled");
        }
      }

      onButtonClick(event) {
        event.preventDefault();
        if (event.currentTarget.name === "next") {
          this.currentPage++;
        } else {
          this.currentPage--;
        }
      
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${this.currentPage}"]`
        );
        const slideItems = this.querySelectorAll(".progress-bar .item");
        if (slideItems) {
           slideItems.forEach((item) => {
          item.style.background = "lightgrey";
          });
        }
       
        const slideActiveItem = this.querySelector("#sliderItem-" + this.currentPage);
        if (slideActiveItem) {
              slideActiveItem.style.background = "#979696";
        }
        this.setActiveThumbnail(thumbnail);

        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-position="${this.currentPage - 1}"]`
        );
        const mediaId = activeMedia?.getAttribute("data-media-id");
        this.setActiveMedia(mediaId, false);
        this.setButtonBehaviour();
      
      }
    }
  );
}

